var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"children-page"},[_c('navBar',{on:{"goBack":_vm.gobackChapter}},[_c('span',{staticClass:"title"},[_vm._v("古今异议")])]),_c('baseInput')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }